<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-select
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      style="width: 100%"
      placeholder=""
      clearable="">
      <el-option
        v-for="sitem in list"
        :key="sitem.envInfoId"
        :label="sitem.envInfoName"
        :value="sitem.envInfoId">
      </el-option>
      <el-option :value="null">
        <el-button
          type="primary"
          style="width: 100%"
          @click.stop="create">新增</el-button>
      </el-option>
    </el-select>
    <span v-else>{{ name }}</span>
    <trace-info-modal
      ref="modal"
      :vendorId="vendorId"
      :envInfoType="3"
      envName="生产环境"
      :fetch="fetchList" />
  </el-form-item>
</template>

<script>
import TraceInfoModal from '@/components/business/traceinfo/trace-info-modal.vue'
export default {
  name: 'WorkFormSelect',
  components: { TraceInfoModal },
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    },
    vendorId: [String, Number]
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      const names = this.list.filter(o => this.form.fieldValue === o.envInfoId)
      return names.map(o => o.envInfoName).join('，')
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'change'
        }
      ]
    }
  },
  watch: {
    vendorId: {
      handler(val) {
        if (val) {
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  methods: {
    create() {
      this.$refs.modal.toggleModal(true)
    },
    fetchList() {
      this.$store.dispatch('traceinfo/gettracingenvinfos', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          envInfoType: 3,
          vendorId: this.vendorId
        },
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => { }
      })
    }
  }
}
</script>
